import { render, staticRenderFns } from "./NotificationsBadge.vue?vue&type=template&id=98ebe43c&scoped=true&"
import script from "./NotificationsBadge.vue?vue&type=script&lang=ts&"
export * from "./NotificationsBadge.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsBadge.vue?vue&type=style&index=0&id=98ebe43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ebe43c",
  null
  
)

export default component.exports